import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';


@Component({
  tag: 'top-switcher',
  styleUrl: 'top-switcher.css',
  shadow: true,
})
export class TopSwitcher {
  /**
   * title
   */
  @Prop() toptitle: string;

  /**
   * Cards Data
   */
  @Prop() cardsData: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;

  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }

  // displaySelectedSlide(selectedIndex) {
  //   // Update active class for slides
  //   const slideToggles = this.el.shadowRoot.querySelectorAll('.top-switcher-tab');
  //   slideToggles.forEach((slide, idx) => {
  //     if (idx === selectedIndex) {
  //       slide.classList.add('active');
  //     } else {
  //       slide.classList.remove('active');
  //     }
  //   });

  //   // Extract data attributes from the selected slide
  //   const activeSlide = slideToggles[selectedIndex];
  //   const iconTitle = activeSlide.getAttribute('data-icon');
  //   const title = activeSlide.getAttribute('data-title');
  //   const description = activeSlide.getAttribute('data-description');
  //   const video = activeSlide.getAttribute('data-video');
  //   const imageUrl = activeSlide.getAttribute('data-image');
  //   const imageAlt = activeSlide.getAttribute('data-alt');
  //   const buttonsJson = activeSlide.getAttribute('data-buttons');
  //   const buttons = buttonsJson ? JSON.parse(buttonsJson) : [];

  //   const assetsContainer = this.el.shadowRoot.querySelector('.top-switcher-slide-asset-container') as HTMLElement;

  //   // Select elements within the component to update their content
  //   const slideContent = this.el.shadowRoot.querySelector('.top-switcher-slide-content');
  //   if (slideContent) {
  //     this.el.shadowRoot.querySelector('.top-switcher-slide-icon-title-mobile').textContent = iconTitle || '';
  //     slideContent.querySelector('.top-switcher-slide-title').textContent = title || '';
  //     slideContent.querySelector('.top-switcher-slide-description').innerHTML = description || '';

  //     if (video) {
  //       // If there's a video URL, add the 'video-active' class to show the video and hide the image
  //       assetsContainer.classList.add('video-active');

  //       // Assuming you have a <video-block> element to update
  //       const videoBlock = this.el.shadowRoot.querySelector('.top-switcher-slide-asset-container video-block') as any;
  //       if (videoBlock) {
  //         videoBlock.videoUrl = video; // Update the video URL
  //       }
  //     } else {
  //       // If there's no video URL, remove the 'video-active' class to show the image and hide the video
  //       assetsContainer.classList.remove('video-active');
  //     }

  //     // For the image, you might need to handle it differently
  //     const imageBlock = this.el.shadowRoot.querySelector('.top-switcher-slide-asset-container image-block') as any;
  //     if (imageBlock) {
  //       // Directly set properties if they're defined on the image-block component
  //       imageBlock.imageUrl = imageUrl || '';
  //       imageBlock.imageAlt = imageAlt || '';
  //       // Assume imageClass is a property; if not, use setAttribute for actual attributes
  //       // imageBlock.imageClass = 'top-switcher-slide-asset';

  //       if (imageUrl === '' || imageUrl === null || imageUrl === undefined) {
  //         assetsContainer.style.display = 'none';
  //       } else {
  //         assetsContainer.style.display = 'block';
  //       }
  //     }

  //     // Handle button blocks
  //     const buttonsContainer = this.el.shadowRoot.querySelector('.top-switcher-slide-buttons');
  //     // Clear existing button-blocks first
  //     buttonsContainer.innerHTML = '';
  //     buttons.forEach(buttonData => {
  //       if (buttonData.cta !== '' || buttonData.cta !== null || buttonData.cta !== undefined) {
  //         const buttonBlock = document.createElement('button-block');
  //         buttonBlock.buttonsData = buttonData;
  //         buttonsContainer.appendChild(buttonBlock);
  //       }
  //     });
  //   }
  // }
  displaySelectedSlide(selectedIndex) {
    const slideToggles = this.el.shadowRoot.querySelectorAll('.top-switcher-tab');

    // Update active class for slides
    slideToggles.forEach((slide, idx) => {
      slide.classList.toggle('active', idx === selectedIndex);
    });

    const activeSlide = slideToggles[selectedIndex];
    const assetsContainer = this.el.shadowRoot.querySelector('.top-switcher-slide-asset-container');
    const slideContent = this.el.shadowRoot.querySelector('.top-switcher-slide-content');

    // Reset or initiate the animation sequence
    this.animateSequence(assetsContainer, activeSlide, slideContent);
  }

  animateSequence(assetsContainer, activeSlide, slideContent) {
    // Start by triggering fade-out animation
    assetsContainer.classList.add('animate-out');
    slideContent.classList.add('animate-out');
    // Listen for the end of the fade-out animation
    assetsContainer.onanimationend = event => {
      if (event.animationName === 'slide-fade-out') {
        assetsContainer.classList.remove('animate-out');
        this.updateContent(activeSlide, assetsContainer, slideContent);
        assetsContainer.classList.add('animate-in');
      } else if (event.animationName === 'slide-fade-in') {
        assetsContainer.classList.remove('animate-in');
        assetsContainer.classList.add('active');
      }
    };

    slideContent.onanimationend = event => {
      if(event.animationName === 'slide-fade-out') {
        slideContent.classList.remove('animate-out');
        this.updateContent(activeSlide, assetsContainer, slideContent);
        slideContent.classList.add('animate-in');
      } else if (event.animationName === 'slide-fade-in') {
        slideContent.classList.remove('animate-in');
        slideContent.classList.add('active');
      }
    }
  }

  updateContent(activeSlide, assetsContainer, slideContent) {
    // Extract data attributes from the selected slide
    const iconTitle = activeSlide.getAttribute('data-icon');
    const title = activeSlide.getAttribute('data-title');
    const description = activeSlide.getAttribute('data-description');
    const video = activeSlide.getAttribute('data-video');
    const imageUrl = activeSlide.getAttribute('data-image');
    const imageAlt = activeSlide.getAttribute('data-alt'); // Correct way to access custom attribute
    const buttonsJson = activeSlide.getAttribute('data-buttons');
    const buttons = buttonsJson ? JSON.parse(buttonsJson) : [];

    // Assuming you have placeholders in your HTML to update these values
    let element;

    element = this.el.shadowRoot.querySelector('.top-switcher-slide-icon-title-mobile');
    if (element) {
      element.textContent = iconTitle ?? '';
    }

    element = slideContent.querySelector('.top-switcher-slide-title');
    if (element) {
      element.textContent = title ?? '';
    }

    element = slideContent.querySelector('.top-switcher-slide-description');
    if (element) {
      element.innerHTML = description ?? '';
    }
    // if (slideContent) {
    //   this.el.shadowRoot.querySelector('.top-switcher-slide-icon-title-mobile').textContent = iconTitle ?? '';
    //   slideContent.querySelector('.top-switcher-slide-title').textContent = title ?? '';
    //   slideContent.querySelector('.top-switcher-slide-description').innerHTML = description ?? '';
    // }

    // Handle video or image content
    if (video) {
      // If there's a video URL, manage video-related elements
      assetsContainer.classList.add('video-active');
      const videoBlock = this.el.shadowRoot.querySelector('.top-switcher-slide-asset-container video-block');
      if (videoBlock) {
        videoBlock.setAttribute('video-url', video); // Assuming you use attributes to pass the video URL
      }
    } else {
      // If there's no video URL, manage image-related elements
      assetsContainer.classList.remove('video-active');
      const imageBlock = this.el.shadowRoot.querySelector('.top-switcher-slide-asset-container image-block');
      if (imageBlock) {
        imageBlock.setAttribute('image-url', imageUrl || ''); // Use setAttribute for custom elements
        imageBlock.setAttribute('alt', imageAlt || '');
      }

      assetsContainer.style.display = imageUrl ? 'block' : 'none';
    }

    // Update buttons
    const buttonsContainer = this.el.shadowRoot.querySelector('.top-switcher-slide-buttons');
    buttonsContainer.innerHTML = ''; // Clear existing buttons
    buttons.forEach(buttonData => {
      if (buttonData.cta) {
        // Assuming 'cta' is part of your button data structure
        const buttonBlock = document.createElement('button-block');
        // Assuming 'buttonsData' is a property to pass data into your custom button element
        buttonBlock.buttonsData = buttonData; // Make sure 'buttonsData' is correctly typed to accept the structure of buttonData
        buttonsContainer.appendChild(buttonBlock);
      }
    });
  }

  componentDidLoad() {
    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.top-switcher-wrapper'),
      () => {
        this.el.shadowRoot.querySelector('.top-switcher-wrapper').classList.add('animate');
      },
      ['.overlay1'],
    );
  }

  render() {
    const cards = JSON.parse(this.cardsData);
  //  console.log(cards[0]);

    return (
      <Host>
        <div
          class={` top-switcher-container ${this.backgroundColor} ${this.paddingBottom} ${this.paddingTop}`}
          style={{ backgroundImage: `url(${this.backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
        >
          {this.toptitle && <h2 class={`top-switcher-top-title`}>{this.toptitle}</h2>}
          <div class={`top-switcher-wrapper container ${this.textColor}`}>
            <div class={`overlay1`}></div>
            <div class={`top-switcher-tabs`}>
              {cards.length > 0 &&
                cards.map(({ title, description, icon_title, buttons, icon_url, icon_alt, image_url, image_alt }, index) => (
                  <div
                    class={`top-switcher-tab ${index === 0 ? 'active' : ''}`}
                    data-title={title}
                    data-description={description}
                    data-icon={icon_title}
                    data-buttons={JSON.stringify(buttons)}
                    data-image={image_url}
                    data-alt={image_alt}
                    onClick={() => this.displaySelectedSlide(index)}
                  >
                    {icon_url && <div class={`top-switcher-tab-icon`} style={{ maskImage: `url(${icon_url})` }} data-alt={icon_alt}></div>}
                    {/* {icon_url && <image-block imageUrl={icon_url} imageAlt={icon_alt} imageClass={`top-switcher-tab-icon`}></image-block>} */}
                    {icon_title && <p class={`top-switcher-tab-title`}>{icon_title}</p>}
                  </div>
                ))}
            </div>
            {cards.length > 0 && (
              <div class={`top-switcher-slide`}>
                <div class={`top-switcher-slide-content`}>
                  {cards[0].title && <h3 class={`top-switcher-slide-title`}>{cards[0].title}</h3>}
                  {cards[0].description && <div class={`top-switcher-slide-description`} innerHTML={cards[0].description}></div>}
                  <div class={`top-switcher-slide-buttons`}>
                    {cards[0].buttons && cards[0].buttons.length > 0 && (
                      cards[0].buttons && cards[0].buttons.map((button, index) => (
                        <button-block key={index} buttonsData={button}></button-block>
                      ))
                    )}
                  </div>
                </div>
                <div class="top-switcher-slide-asset-container" style={{ display: cards[0].image_url !== '' ? 'block' : 'none' }}>
                  <image-block imageUrl={cards[0].image_url} imageAlt={cards[0].image_alt} imageClass={`top-switcher-slide-asset`}></image-block>
                </div>
                {cards[0].icon_title && <p class={`top-switcher-slide-icon-title-mobile`}>{cards[0].icon_title}</p>}
              </div>
            )}
            <div class="top-switcher-border"></div>
          </div>
        </div>
      </Host>
    );
  }
}
